function replacePixPlace(){
  setTimeout(() => {

    document.querySelectorAll('.pix_value.showcase > span[data-price]').forEach((pixEl) => {
      pixEl.querySelector('span.pix-value').innerHTML = pixEl.dataset.price;
    })
    
    document.querySelectorAll('#parcelator.parcelatorCollection').forEach((pixEl) => {
        pixEl.parentElement.prepend(pixEl);
      });
    document.querySelectorAll('#parcelator.parcelatorProduct').forEach((pixEl) => {
        pixEl.parentElement.prepend(pixEl);
      });

      
observer.observe(targetNode, config);
    
  }, 400);
}

document.addEventListener('DOMContentLoaded', () => {
  replacePixPlace()
});

// Watch DOM changes
const targetNode = document.querySelector("div.pdp-price");
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      console.log('CHANGED')
      var ele = document.querySelector('#parcelator.parcelatorProduct');
      console.log('ele', ele)
      if(ele && ele?.parentNode){
        console.log('asdalsdçsa', Array.from(ele.parentNode.children).indexOf(ele) != 1 )
        replacePixPlace();        
        observer.disconnect();
        // observer.observe(targetNode, config);

      }
    }
  }
};

const observer = new MutationObserver(callback);


